import CompanyProfile from './CompanyProfile';

function Dashboard() {
    return (
        <div className="container-fluid">

            <div className="row g-4">
                <CompanyProfile />
            </div>
        </div>
    );
}

export default Dashboard;